import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'mes'
})

export class MesPipe implements PipeTransform {
    transform(value: any, args: any[]): any {
        if (value != undefined && value != null) {
            var meses = ["JANEIRO",
                         "FEVEREIRO", 
                         "MARÇO", 
                         "ABRIL", 
                         "MAIO", 
                         "JUNHO", 
                         "JULHO", 
                         "AGOSTO", 
                         "SETEMBRO", 
                         "OUTUBRO", 
                         "NOVEMBRO", 
                         "DEZEMBRO"];

            var mes = "";
            if (value > 0 && value <= 13)
                mes = meses[value - 1];

            return mes;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/core/pipes/mes.pipe.ts
 **/